import React, { Component, useState } from 'react';
// import config from '../../config';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  // LayoutSingleColumn,
  // LayoutWrapperTopbar,
  // LayoutWrapperMain,
  // LayoutWrapperFooter,
  Footer,
  ExternalLink,
  // NamedLink,
  // NewsletterForm,
  // Slider_team,
  // SectionHowItWorks,
  SectionValues,
  ImpactRepSection,
} from '../../components';

import SectionImpact from '../../components/SectionImpact/SectionImpact';

// pulling in cookies for seo
import Cookies from 'universal-cookie';

import { FormattedMessage } from '../../util/reactIntl';

import LazyLoad from 'react-lazyload';

import css from './AboutPage.css';

import MrThy from '../../assets/aboutPage/Mr_thy.png';
import MrThyLines from '../../assets/aboutPage/Mr_thy_lines.png';

import Founder from '../../assets/aboutPage/founder.png';

import insta from '../../assets/icons/socialmedia/instagram-icon.png';
import fb from '../../assets/icons/socialmedia/facebook-icon.png';
import linkedIn from '../../assets/icons/socialmedia/linkedIn-icon.png';

import { TweenMax } from 'gsap/all';

import cloud1 from '../../assets/clouds/cloud1.png';
import Houses from '../../assets/aboutPage/houses.png';
import Plus from '../../assets/aboutPage/plus.png';
import Traveler from '../../assets/aboutPage/traveler.png';

// import article1 from '../../assets/partners/BMWi.png';
// import article2 from '../../assets/partners/ClaimESF.png';
import article3 from '../../assets/partners/ECPAT.png';
import article4 from '../../assets/partners/Enactus.png';
// import article5 from '../../assets/partners/ESF.png';
// import article6 from '../../assets/partners/EU.png';
// import article7 from '../../assets/partners/Exist.png';
import article8 from '../../assets/partners/Gateway.png';
import article9 from '../../assets/partners/GIZ.png';
import article10 from '../../assets/partners/ImpactFactory.png';
//import article11 from '../../assets/partners/JoinMyTrip.png';
import article11 from '../../assets/partners/far_Logo.jpg';
import article12 from '../../assets/partners/Bmwk-big-.png';
import article13 from '../../assets/partners/Animondial.png';
import article14 from '../../assets/partners/Exist.png';
import article15 from '../../assets/partners/SEND.png';
import article16 from '../../assets/partners/planetera.png';
import article17 from '../../assets/partners/gruendungpreis.png';
import article18 from '../../assets/articles/article17.webp';
import heroImage from '../../assets/aboutPage/heroImage.webp';
import LoaderImage1 from '../../assets/loader/world.png';
import LoaderImage2 from '../../assets/loader/airplane.png';
import SectionOurTeam from '../../components/SectionOurTeam/sectionOurTeam';

export class AboutPage extends Component {
  constructor(props) {
    super(props);
    // Don't call this.setState() here!
    this.state = {
      loadingState: false,
      pictureInView: false,
      changeBlueTxt: false,
      changeOrangeTxt: false,
    };
    this.ThyEle = React.createRef();
  }

  componentDidMount() {
    if (window !== undefined) window.scrollTo({ top: 0 });
    var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

    function preventDefault(e) {
      e.preventDefault();
    }

    function preventDefaultForScrollKeys(e) {
      if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
      }
    }

    // modern Chrome requires { passive: false } when adding event
    // reinvestigate this - weasel
    var supportsPassive = false;
    try {
      window.addEventListener(
        'test',
        null,
        Object.defineProperty({}, 'passive', {
          get: function() {
            supportsPassive = true;
          },
        })
      );
    } catch (e) {}

    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

    //Check if drawing is in viewport
    this.ThyEle = React.createRef();
    // var TEL = this.ThyEle;
    // const stateChange = this.setState();
    // const Ostate = this.state;
    window.addEventListener('scroll', () => {
      if (this.ThyEle.current) {
        var top = this.ThyEle.current.getBoundingClientRect().top;
        var bottom = this.ThyEle.current.getBoundingClientRect().bottom;
        var viewportHeight = window.innerHeight;
      }
      if (top + bottom >= 0 && top <= viewportHeight) {
        this.setState({ ...this.state, pictureInView: true });
      } else {
        this.setState({ ...this.state, pictureInView: false });
      }
    });
    if (window !== undefined) window.wheelEvent = function() {};

    // call this to Disable
    function disableScroll() {
      window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
      window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
      window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
      window.addEventListener('keydown', preventDefaultForScrollKeys, false);
    }

    // call this to Enable
    function enableScroll() {
      window.removeEventListener('DOMMouseScroll', preventDefault, false);
      window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
      window.removeEventListener('touchmove', preventDefault, wheelOpt);
      window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
    }
    disableScroll();

    setTimeout(() => {
      enableScroll();
    }, 2500);

    if (window !== undefined && window.location.hash) {
      window.location = '/about';
    }

    var isMobile = false; //initiate as false
    // device detection
    if (typeof window !== 'undefined') {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
          navigator.userAgent
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          navigator.userAgent.substr(0, 4)
        )
      ) {
        isMobile = true;
      }
    }

    document.onscroll = function() {
      if (window !== undefined) {
        var pos = (document.body.parentNode.scrollTop / window.innerHeight) * 100;
      }

      if (window !== undefined && window.location.pathname === '/about') {
        if (isMobile === false) {
          if (pos < 29) {
            window.location.hash = '#sectionZero';
          }
          if (pos < 49 && pos > 30) {
            window.location.hash = '#sectionOne';
          }
          if (pos > 50 && pos < 199) {
            window.location.hash = '#sectionTwo';
          }
          if (pos > 199 && pos < 299) {
            window.location.hash = '#sectionThree';
          }
          if (pos > 300 && pos < 549) {
            window.location.hash = '#sectionFour';
          }
          if (pos > 550) {
            window.location.hash = '#sectionFive';
          }
        } else {
          if (pos < 0 && pos < 49) {
            window.location.hash = '#sectionOne';
          }
          if (pos > 50) {
            window.location.hash = '#sectionThree';
          }
        }
      }
    };
  }

  handleImageLoaded() {
    setTimeout(() => {
      this.setState({ loadingState: true });

      var element = document.getElementById('heroWrapper');
      element.classList.add(css.heroWrapper_active);

      setTimeout(() => {
        var targetTop = document.querySelector('#topbar');
        targetTop.style.opacity = 1;

        TweenMax.staggerFrom(
          targetTop,
          0.75,
          {
            opacity: 0,
          },
          0.67
        );

        var target = document.querySelector('#anima');
        var target1 = document.querySelector('#anima1');
        var target3 = document.querySelector('#anima3');

        target.style.opacity = 1;
        target1.style.opacity = 1;

        TweenMax.staggerFrom(
          target,
          1,
          {
            skewX: '5deg',
            skewY: '5deg',
            opacity: 0,
            y: 180,
            // ease: Power4.easeOut
          },
          0.27
        );

        TweenMax.staggerFrom(
          target1,
          1.5,
          {
            skewX: '5deg',
            skewY: '5deg',
            opacity: 0,
            y: 180,
            // ease: Power4.easeOut
          },
          0.27
        );

        setTimeout(() => {
          target3.style.opacity = 1;

          TweenMax.staggerFrom(
            target3,
            0.75,
            {
              skewX: '-5deg',
              skewY: '-5deg',
              opacity: 0,
              y: -70,
              // ease: Power4.easeOut
            },
            0.67
          );
        }, 1000);
      }, 1000);
    }, 500);
  }

  changeBlueText() {
    this.setState({
      changeBlueTxt: true,
      changeOrangeText: false
    });
  }
  changeOrangeText() {
    this.setState({
      changeOrangeTxt: true,
      changeBlueTxt: false
    });
  }

  changetxtToOriginal() {
    this.setState({
      changeOrangeTxt: false,
      changeBlueTxt: false,
    });
  }


  render() {
    // investigate - weasel
    var isMobile = false; //initiate as false
    // device detection

    if (window !== undefined) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
          navigator.userAgent
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          navigator.userAgent.substr(0, 4)
        )
      ) {
        isMobile = true;
      }
    }

    const whyWrapperContent = this.state.loadingState === true && (
      <div className={css.section}>
        <div className={css.whyWrapper}>
          <div className={css.whyTextWrapper}>
            <div className={css.whyTextHeaderWrapper}>
              <h1 id="anima" className={css.whyTextHeader} style={{ fontSize: '32px' }}>
                <FormattedMessage id="about.whyTextblock1Header" />
              </h1>
            </div>
            <div className={css.text}>
              <p>
                <FormattedMessage id="about.whyTextblock1Text" />
              </p>
            </div>
          </div>
          <div className={css.whyTextWrapper}>
            <div className={css.whyTextHeaderWrapper}>
              <h1
                id="anima"
                className={`${css.whyTextHeader} ${css.whyTextBlock2Header}`}
                style={{ fontSize: '32px' }}
              >
                <FormattedMessage id="about.whyTextblock2Header" />
              </h1>
            </div>
            <div className={css.text}>
              <p>
                <FormattedMessage id="about.whyTextblock2Text" />
              </p>
            </div>
          </div>
        </div>
        <div className={css.imagesWrapper}>
          <div className={`${css.imagesItemsOuter} ${css.houses}`}>
            <img src={Houses} alt="houses"></img>
          </div>
          <div className={css.imagesItemsInner}>
            <img src={Plus} alt="additional"></img>
          </div>
          <div className={`${css.imagesItemsOuter} ${css.traveller}`}>
            <img src={Traveler} alt="traveller"></img>
          </div>
          </div>
          <hr className={css.divider}></hr>
        <div className={css.section_graph}>
          <div className={css.graphText}>
            {(() => {
              if (this.state.changeBlueTxt) {
                return (
                  <>
                    <h3>
                      <FormattedMessage id="about.lightGrayTxt" />
                    </h3>
                    <h1 className={css.blueTitle}>
                      <FormattedMessage id="about.graphBlueTitle" />{' '}
                    </h1>
                    <p>
                      <FormattedMessage id="about.graphBlueTxt" />
                    </p>
                  </>
                );
              } else if (this.state.changeOrangeTxt) {
                return (
                  <>
                    <h3>
                      <FormattedMessage id="about.lightGrayTxt" />
                    </h3>
                    <h1 className={css.orangeTitle}>
                      <FormattedMessage id="about.graphOrangeTitle" />
                    </h1>
                    <p>
                      <FormattedMessage id="about.graphOrangeTxt" />
                    </p>
                  </>
                );
              }
              return (
                <>
                  <h3>
                    <FormattedMessage id="about.lightGrayTxt" />
                  </h3>
                  <h1 className={css.blueTitle}>
                    <FormattedMessage id="about.graphOriginalTitle" />
                  </h1>
                  <p>
                    <FormattedMessage id="about.graphOriginalTxt" />
                  </p>
                </>
              );
            })()}
          </div>
          <div className={css.middleLine}></div>
          <div className={css.graphSection}>
            <svg
              className={css.Layer_1}
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 778.71 662.63"
              onMouseLeave={this.changetxtToOriginal.bind(this)}
            >
              <title>Svg Graph</title>
              <g
                className={css.rightBGraph}
                onMouseOver={(e) => {e.preventDefault();this.changeBlueText.bind(this)}}
                onMouseEnter={this.changeBlueText.bind(this)}
              >
                <path
                  className={css.rightline}
                  d="M821.36,205.87V478.63h-5.94c-32.31,0-64.64.07-97-.08h-8.29V465.75h8.29l82,.16c7.39,0,7.39,0,7.39-7.37,0-115.28,0-127.5,0-242.83,0-11.75-2-10.2,10.81-10.28A18,18,0,0,1,821.36,205.87Z"
                  transform="translate(-42.64 -100.68)"
                  fill="#606161"
                />
                <path
                  className={css.rightgraph}
                  d="M495.6,536.93,595.71,719.28c59-35.52,103.07-83.68,132.19-145.39.52-1.11,9.3-21.41,9.3-21.41C751.56,514,759.36,475,759.2,434l-208.64,1.67C549,478.57,530.81,512.15,495.6,536.93Z"
                  transform="translate(-42.64 -100.68)"
                  fill="#010101"
                  onMouseOver={(e) => {e.preventDefault();this.changeBlueText.bind(this)}}
                  onMouseEnter={this.changeBlueText.bind(this)}
                />
                <text
                  transform="translate(740 97.35)"
                  font-size="48"
                  fill="#231f20"
                  font-family="MyriadPro-Bold, Myriad Pro"
                  className={css.rightGtxt}
                  fontWeight="700"
                >
                  15%
                </text>
              </g>
              <g
                className={css.leftOGraph}
                onClick={(e) => {e.preventDefault();this.changeOrangeText.bind(this)}}
                onMouseOver={(e) => {e.preventDefault();this.changeOrangeText.bind(this)}}
                onMouseEnter={this.changeOrangeText.bind(this)}
              >
                <path
                  className={css.leftline}
                  d="M42.64,738.68V465.92h5.94c32.31,0,64.64-.07,97,.08h8.29v12.79h-8.29l-82-.16c-7.39,0-7.39,0-7.39,7.37,0,115.28,0,127.5,0,242.83,0,11.75,2,10.2-10.81,10.28A18,18,0,0,1,42.64,738.68Z"
                  transform="translate(-42.64 -100.68)"
                  fill="#606161"
                 onMouseOver={(e) => {e.preventDefault();this.changeOrangeText.bind(this)}}
                  onMouseEnter={this.changeOrangeText.bind(this)}
                />
                 <path
                  className={css.leftgraph}
                  d="M550.18,433.92l209.54-1.59C755.73,308.46,702.07,214,598,147L489.83,330.1C528.26,354.09,548.26,388.67,550.18,433.92Z"
                  transform="translate(-42.64 -100.68)"
                  fill="#010101"
                  onMouseOver={(e) => {e.preventDefault();this.changeOrangeText.bind(this)}}
                  onMouseEnter={this.changeOrangeText.bind(this)}
                />
               <path
                  className={css.leftgraph}
                  d="M265.37,711.49l0,0L364.47,547a7.44,7.44,0,0,0-2.16-10h-.05c-34.92-24-53.83-56.83-54.91-99.4-.13-5-2-6-6.47-6q-95.71-.77-191.42-1.82c-11.44-.12-11.41-.15-11.17,11.34A325.7,325.7,0,0,0,125,563.17c.44,1,10.19,21.29,10.4,21.7,27.2,51,64.16,92.53,112.24,124.35,2.46,1.63,5,3.18,7.53,4.73A7.45,7.45,0,0,0,265.37,711.49Z"
                  transform="translate(-42.64 -100.68)"
                  fill="#010101"
                 onMouseOver={(e) => {e.preventDefault();this.changeOrangeText.bind(this)}}
                  onMouseEnter={this.changeOrangeText.bind(this)}
                />
               <path
                  className={css.leftgraph}
                  d="M487.87,329.19,596.62,145.92q-90.15-51.95-193-44.24A322.34,322.34,0,0,0,266.7,143.37L371.07,328.08C410.51,308.64,449.22,309.24,487.87,329.19Z"
                  transform="translate(-42.64 -100.68)"
                  fill="#010101"
                  onMouseOver={(e) => {e.preventDefault();this.changeOrangeText.bind(this)}}
                  onMouseEnter={this.changeOrangeText.bind(this)}
                />
               <path
                  className={css.leftgraph}
                  d="M103.45,427.62q99,.73,197.89,1.89c4.5,0,5.82-1.27,6.29-5.77,3.5-33.73,18.34-61.52,44.69-83,5.14-4.18,10.77-7.76,16.65-12L264.88,144.54c-1.81,1-3.28,1.75-4.69,2.58A310.94,310.94,0,0,0,205,188.22c-67.15,63.33-103.12,141-106.74,233.39C98.07,425.63,98.63,427.58,103.45,427.62Z"
                  transform="translate(-42.64 -100.68)"
                  fill="#010101"
                  onMouseOver={(e) => {e.preventDefault();this.changeOrangeText.bind(this)}}
                  onMouseEnter={this.changeOrangeText.bind(this)}
                />
                <path
                   className={css.leftgraph}
                  d="M370,542,263.45,718.83c111.87,65.7,246,52.48,330.4.31l-100.78-181C452.37,561.61,411.48,562.54,370,542Z"
                  transform="translate(-42.64 -100.68)"
                  fill="#010101"
                 onMouseOver={(e) => {e.preventDefault();this.changeOrangeText.bind(this)}}
                  onMouseEnter={this.changeOrangeText.bind(this)}
                />
                <text
                  transform="translate(-26 679.35)"
                  font-size="48"
                  fill="#231f20"
                  font-family="MyriadPro-Bold, Myriad Pro"
                  fontWeight="700"
                  className={css.leftGtxt}
                >
                  85%
                </text>
              </g>
            </svg>
          </div>
        </div>
        <hr className={css.divider}></hr>

<SectionOurTeam />

        <hr className={css.divider}></hr>
        <SectionValues></SectionValues>
      </div>
    );

    const content = (
      <div style={{ overflow: 'hidden' }}>
        <div id="topbar" className={css.topbar} style={{ position: 'fixed', width: '100vw' }}>
          <TopbarContainer />
        </div>

        <div className={css.LeftFooterContent}>
          <ExternalLink
            href="https://www.instagram.com/socialbnb"
            target="_blank"
            className={css.socialmedia}
          >
            <img src={insta} className={css.socialmedia} alt="instagram"></img>
          </ExternalLink>

          <ExternalLink
            href="https://www.facebook.com/Socialbnb"
            target="_blank"
            className={css.socialmedia}
          >
            <img src={fb} className={css.socialmedia} alt="facebook"></img>
          </ExternalLink>

          <ExternalLink
            href="https://www.linkedin.com/company/socialbnb/"
            target="_blank"
            className={css.socialmedia}
          >
            <img src={linkedIn} className={css.socialmedia} alt="facebook"></img>
          </ExternalLink>
        </div>
        <div className={css.section}>
          <div
            id="heroWrapper"
            className={css.heroWrapper}
            style={{ margnTop: '0', height: '100vh', overflow: 'hidden' }}
          >
            <div className={css.HeaderWrapper}>
              <div className={css.HeaderWrapperRow}>
                <h1 id="anima" className={css.Header1}>
                  <FormattedMessage id="about.headline1" />
                </h1>
              </div>
              <div className={css.HeaderWrapperRow}>
                <h1 id="anima1" className={css.Header1}>
                  <FormattedMessage id="about.headline2" />
                </h1>
              </div>

              <div className={css.HeaderWrapperRowSecond}>
                <div id="anima3" className={css.SubHeader1}>
                  <p>
                    <FormattedMessage id="about.subHeadline" />
                  </p>
                </div>
              </div>
            </div>

            <div className={css.cloudsOuter}>
              <img className={css.clouds} alt="clouds" src={cloud1}></img>
            </div>
            <img
              className={css.heroImage}
              src={heroImage}
              alt="heroImage"
              width="100%"
              onLoad={this.handleImageLoaded.bind(this)}
            />
          </div>
        </div>

        {/* VIDEO
          <div className={css.section}>
            <div className={css.videoWrapper}>
              <div className={css.showVideoicon}></div>
              <img src={video} width="100%" className={css.videoImage}></img>
            </div>
          </div> */}

        <div className={css.section}>
          <div className={css.storyWrapper}>
            <div className={css.storyPhotoWrapper}>
              <img src={MrThyLines} alt="mrThylines" className={css.storyPhoto1}></img>
              <img
                ref={this.ThyEle}
                src={MrThy}
                className={
                  //window.location.hash === '#sectionTwo' ? css.storyPhoto : css.storyPhoto_hide
                  this.state.pictureInView ? css.storyPhoto2 : css.storyPhoto_hide
                }
                alt=""
              ></img>
            </div>
            <div className={css.storyTextWrapper}>
              <div className={css.whyTextWrapper}>
                <div className={css.storyTextHeaderWrapper}>
                  <h1 id="anima" className={css.whyTextHeader}>
                    <FormattedMessage id="about.storyHeadline" />
                  </h1>
                </div>

                <div className={css.text}>
                  <p>
                    <FormattedMessage id="about.storyTextBlock1" />
                    {/* <br /> <br />
                  <FormattedMessage id="about.storyTextBlock2" />
                  <br /> <br />
                  <FormattedMessage id="about.storyTextBlock3" /> */}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className={css.divider}></hr>
        {whyWrapperContent}
        <hr className={css.divider}></hr>
        <SectionImpact />
        <ImpactRepSection/>

        <div className={css.section4}>
          <div className={css.partnersWrapper}>
            <div className={css.partnersHeaderWrapper}>
              <h1 id="partner" className={css.partnersHeader}>
                <FormattedMessage id="about.partnersHeadline" />
              </h1>
            </div>
            <div className={css.articles}>
              <div className={css.articlesItems}>
                <ExternalLink href="https://ecpat.de/" target="_blank" style={{ height: '100%' }}>
                  <img src={article3} alt="article3"></img>
                </ExternalLink>
              </div>

              <div className={css.articlesItems}>
                <ExternalLink
                  href="https://www.enactus.de/uni-koeln/"
                  target="_blank"
                  style={{ height: '100%' }}
                >
                  <img src={article4} alt="article4"></img>
                </ExternalLink>
              </div>

              <div className={css.articlesItems}>
                <ExternalLink
                  href="https://www.gateway.uni-koeln.de/"
                  target="_blank"
                  style={{ height: '100%' }}
                >
                  <img src={article8} alt="article8"></img>
                </ExternalLink>
              </div>

              <div className={css.articlesItems}>
                <ExternalLink
                  href="https://www.giz.de/de/html/index.html"
                  target="_blank"
                  style={{ height: '100%' }}
                >
                  <img src={article9} alt="article9"></img>
                </ExternalLink>
              </div>

              <div className={css.articlesItems}>
                <ExternalLink
                  href="https://impact-factory.de/"
                  target="_blank"
                  style={{ height: '100%' }}
                >
                  <img src={article10} alt="article10"></img>
                </ExternalLink>
              </div>

              <div className={css.articlesItems}>
                <ExternalLink
                  href="https://forumandersreisen.de/startseite/aktuelles/"
                  target="_blank"
                  style={{ height: '100%' }}
                >
                  <img src={article11} alt="article11"></img>
                </ExternalLink>
              </div>

              <div className={css.articlesItems}>
                <ExternalLink
                  href="https://www.bmwk.de/Navigation/DE/Home/home.html"
                  target="_blank"
                  style={{ height: '100%' }}
                >
                  <img src={article12} alt="article12"></img>
                </ExternalLink>
              </div>

              <div className={css.articlesItems}>
                <ExternalLink
                  href="https://www.unwto.org/unwto-awake-tourism-challenge"
                  target="_blank"
                  style={{ height: '100%' }}
                >
                  <img src={article18} alt="article18"></img>
                </ExternalLink>
              </div>

              <div className={css.articlesItems}>
                <ExternalLink
                  href="https://animondial.com/"
                  target="_blank"
                  style={{ height: '100%' }}
                >
                  <img src={article13} alt="article13"></img>
                </ExternalLink>
              </div>

              <div className={css.articlesItems}>
                <ExternalLink
                  href="https://www.exist.de/EXIST/Navigation/DE/Home/home.html"
                  target="_blank"
                  style={{ height: '100%' }}
                >
                  <img src={article14} alt="article14"></img>
                </ExternalLink>
              </div>

              <div className={css.articlesItems}>
                <ExternalLink
                  href="https://planeterra.org/"
                  target="_blank"
                  style={{ height: '100%' }}
                >
                  <img src={article16} alt="article16"></img>
                </ExternalLink>
              </div>

              <div className={css.articlesItems}>
                <ExternalLink
                  href="https://www.de.digital/DIGITAL/Navigation/DE/Home/home.html"
                  target="_blank"
                  style={{ height: '100%' }}
                >
                  <img src={article17} alt="article17"></img>
                </ExternalLink>
              </div>

              <div className={css.articlesItems}>
                <ExternalLink
                  href="https://www.send-ev.de/"
                  target="_blank"
                  style={{ height: '100%' }}
                >
                  <img src={article15} alt="article15"></img>
                </ExternalLink>
              </div>
            </div>
          </div>
        </div>
        <div className={`${css.section} ${css.section5}`}>
          <LazyLoad height={400} offset={100} once>
            <Footer />
          </LazyLoad>
        </div>
      </div>
    );

    const loader =
      this.state.loadingState === false ? (
        <div className={css.loader}>
          <img
            src={LoaderImage2}
            alt="loaderImage"
            className={css.loaderImage2}
            width="100px"
          ></img>

          <img
            src={LoaderImage1}
            alt="loaderImage1"
            className={css.loaderImage1}
            width="100px"
          ></img>
          {/* <CircularProgress size={50} thickness={2} style={{ color: '#353535' }} /> */}
        </div>
      ) : null;

    const cookies = new Cookies();

    return (
      <StaticPage
        title={cookies.get('language') === 'en' ? 'About socialbnb' : 'Über socialbnb'}
        description={
          cookies.get('language') === 'en'
            ? 'socialbnb is the social travel startup focusing on a social added value in sustainable tourism. Find out more about our mission, team and work.'
            : 'socialbnb ist das soziale Reise Startup mit Fokus auf einem gesellschaftlichen Mehrwert im nachhaltigen Tourismus. Erfahre mehr über unsere Mission, unser Team und unsere Arbeit.'
        }
        keywords={
          cookies.get('language') === 'en'
            ? 'about Us page, social travel startup, social added value, sustainable tourism, how did socialbnb come about, who is behind socialbnb'
            : 'Über Uns Seite, soziales Reise Startup, gesellschaftlicher Mehrwert, nachhaltiger Tourismus, wie ist socialbnb entstanden, wer steckt hinter socialbnb'
        }
        schema={{
          '@context': 'http://schema.org',
          '@type': 'AboutPage',
          url: 'https://socialbnb.org/about',
        }}
      >
        <div className={css.Wrapper}>
          {loader} {content}
        </div>
        <>
          {this.state.changeOrangeTxt}
          {this.state.changeBlueTxt}
        </>
      </StaticPage>
    );
  }
}

export default AboutPage;
